export default __webpack_public_path__ + "static/media/APVMAIcon.db714fcd.png";